// Anything you export in this file ends up in the bundle
// even if the app doesn't use it, so be careful!

import DOMPurify from "dompurify";
import ReactDOM from "react-dom/client";
import { Fragment, createElement, useState, useRef, useEffect } from "react";
import Fuse from "fuse.js";
import {
	CircularProgress,
	Chip,
	Fab,
	Menu,
	MenuItem,
	Dialog,
	Tabs,
	Tab,
	Button,
} from "@mui/material";

import { confirmDialog } from "./components/ConfirmDialog";

window.bundle = {
	DOMPurify,
	ReactDOM,
	createElement,
	useState,
	useRef,
	useEffect,
	Fragment,
	Fuse,
	CircularProgress,
	Chip,
	Fab,
	Menu,
	MenuItem,
	Dialog,
	Tabs,
	Tab,
	Button,
	confirmDialog,
};
